import { Injectable } from '@angular/core';
import { Bank } from '../../agatextscreens/accounting/bank';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../../agatextscreens/accounting/branch';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Configuration } from '../../app.constants';
import { AuthenticationService } from './authentication.service';
import { Ledger } from '../../agatextscreens/accounting/ledger';

@Injectable()
export class BankService {
  private _banksUrl = this._configuration.apiUrl + "/v2/bank";

  constructor(private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }

  createBank(bank: Bank): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.post(this._banksUrl, bank, { headers: h, search: s }).map(response => response.json());
  }

  getBanks(restricted: boolean = false): Observable<Bank[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    if (restricted) {
      s.append('restricted', '1');
    }

    return this._http.get(this._banksUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['banks'] == null || !Array.isArray(body['banks']))
          return [];
        return body['banks'];
      }
    );
  }

  getOneBank(bank_id: string): Observable<Bank[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('bank_id', bank_id);

    return this._http.get(this._banksUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['banks'] == null || !Array.isArray(body['banks']))
          return [];
        return body['banks'];
      }
    );
  }

  getLedger(bank_id: string): Observable<Ledger> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('bank_id', bank_id);
    s.append('ledger', 'true');

    return this._http.get(this._banksUrl, { headers: h, search: s }).map(response => response.json());
  }

  deposit(bank_id, description, amount, date) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('bank_id', bank_id);
    s.append('deposit', 'true');

    return this._http.put(this._banksUrl,
      {
        description: description,
        date: date,
        in: amount,
        bank_id: bank_id
      },
      { headers: h, search: s }).map(response => response.json());
  }

  withdrawal(bank_id, description, amount, vat, date) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('bank_id', bank_id);
    s.append('withdrawal', 'true');

    return this._http.put(this._banksUrl,
      {
        description: description,
        date: date,
        out: amount,
        vat: vat,
        bank_id: bank_id
      },
      { headers: h, search: s }).map(response => response.json());
  }

  transfer(description, date, from_amount, from_bank_id, to_amount, to_bank_id) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('transfer', 'true');

    return this._http.put(this._banksUrl,
      {
        description: description,
        date: date,
        from_amount: from_amount,
        from_bank_id: from_bank_id,
        to_amount: to_amount,
        to_bank_id: to_bank_id
      },
      { headers: h, search: s }).map(response => response.json());
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/services/bank.service.ts